"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquizLinkWidget = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const resource_browser_1 = require("@squiz/resource-browser");
const formatted_text_editor_1 = require("@squiz/formatted-text-editor");
const validateForm_1 = require("./utils/validateForm");
const RequiredFieldMarker_1 = __importDefault(require("../../../global/RequiredFieldMarker/RequiredFieldMarker"));
function formDataIsManualFormData(formData) {
    return (formData &&
        typeof formData === 'object' &&
        typeof formData['text'] === 'string' &&
        typeof formData['url'] === 'string' &&
        typeof formData['target'] === 'string');
}
function determineFormDataType(formData) {
    return formDataIsManualFormData(formData) ? 'manual' : 'asset';
}
const SquizLinkWidget = ({ disabled, formData, onChange, schema }) => {
    const [pickerType, setPickerType] = (0, react_1.useState)(() => determineFormDataType(formData));
    const [target, setTarget] = (0, react_1.useState)(formData?.target ?? '_self');
    const { matrix } = (0, react_1.useContext)(formatted_text_editor_1.EditorContext);
    const [errors, setErrors] = (0, react_1.useState)({
        text: '',
        url: '',
    });
    // TODO: this function (and by extension "validateForm") is not called. remove or use in the logic.
    (0, react_1.useCallback)(() => {
        if (pickerType === 'manual') {
            const isFormValid = (0, validateForm_1.validateForm)(errors, formData, setErrors);
            if (isFormValid === false) {
                onChange(undefined);
            }
        }
        if (pickerType === 'asset') {
            if (formData?.matrixAssetId === undefined ||
                formData?.matrixDomain === undefined ||
                formData?.matrixDomain === undefined) {
                onChange(undefined);
            }
        }
    }, [pickerType]);
    const [metaFormData, setFormData] = (0, react_1.useState)(() => {
        if (determineFormDataType(formData) === 'asset') {
            return {
                ...formData,
                target: target,
                text: '',
                url: '',
            };
        }
        else {
            return {
                ...formData,
            };
        }
    });
    const handlePickerTypeChange = (type) => {
        if (type !== pickerType) {
            setPickerType(type);
        }
        if (type === 'asset') {
            const updatedData = {
                text: undefined,
                url: undefined,
                target: target,
                matrixAssetId: (metaFormData?.matrixAssetId || formData?.matrixAssetId) ?? undefined,
                matrixDomain: (metaFormData?.matrixDomain || formData?.matrixDomain) ?? undefined,
                matrixIdentifier: (metaFormData?.matrixIdentifier || formData?.matrixDomain) ?? undefined,
            };
            onChange(updatedData);
        }
        if (type === 'manual') {
            const updatedData = {
                text: metaFormData.text,
                url: metaFormData.url,
                target: target,
                matrixAssetId: undefined,
                matrixDomain: undefined,
                matrixIdentifier: undefined,
            };
            onChange(updatedData);
        }
    };
    const handleManualFieldChange = (e, field) => {
        if (field === 'text') {
            const updatedData = {
                text: e.target.value,
                target: target,
                url: metaFormData.url,
                matrixAssetId: undefined,
                matrixDomain: undefined,
                matrixIdentifier: undefined,
            };
            setFormData(updatedData);
            onChange(updatedData);
        }
        if (field === 'url') {
            const updatedData = {
                text: metaFormData.text,
                target: target,
                url: e.target.value,
                matrixAssetId: undefined,
                matrixDomain: undefined,
                matrixIdentifier: undefined,
            };
            setFormData(updatedData);
            onChange(updatedData);
        }
    };
    const handleTargetChange = (e) => {
        const newTarget = e.target.value;
        setTarget(newTarget);
        const updateData = {
            ...formData,
            target: newTarget,
        };
        onChange(updateData);
    };
    const handleReferenceChange = (resource) => {
        const referenceData = resource
            ? {
                matrixAssetId: resource.id,
                matrixDomain: matrix?.matrixDomain,
                matrixIdentifier: resource.source.id,
            }
            : undefined;
        const updatedData = {
            ...referenceData,
            target: target,
        };
        setFormData({
            ...metaFormData,
            matrixAssetId: resource?.id ?? undefined,
            matrixDomain: matrix?.matrixDomain,
            matrixIdentifier: resource?.source.id ?? undefined,
        });
        onChange(updatedData);
    };
    return (react_1.default.createElement("div", { className: "component-squiz-link component-group flex flex-col gap-2" },
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { htmlFor: "picker-select" },
                "Link type",
                react_1.default.createElement(RequiredFieldMarker_1.default, { tooltipMessage: "This field is required" })),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { id: "picker-select", as: "select", custom: true, value: pickerType, onChange: (e) => handlePickerTypeChange(e.target.value), disabled: disabled },
                react_1.default.createElement("option", { value: "asset" }, "Matrix asset"),
                react_1.default.createElement("option", { value: "manual" }, "Custom URL"))),
        react_1.default.createElement("div", { className: "flex flex-col gap-2 !mb-0" }, pickerType === 'asset' ? (react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { id: "matrix-asset" }, "Matrix asset"),
            react_1.default.createElement("div", { className: "bg-white w-min" },
                react_1.default.createElement(resource_browser_1.ResourceBrowser, { "aria-labelledby": "matrix-asset", modalTitle: "Select Asset", allowedTypes: schema.matrixAssetTypes, isDisabled: disabled, onChange: handleReferenceChange, value: formData && metaFormData.matrixAssetId && metaFormData.matrixIdentifier
                        ? {
                            resourceId: metaFormData.matrixAssetId ?? formData.matrixAssetId,
                            sourceId: metaFormData.matrixIdentifier ?? formData.matrixAssetId,
                        }
                        : null })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "form-group" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { htmlFor: "text" },
                    "Text",
                    react_1.default.createElement(RequiredFieldMarker_1.default, { tooltipMessage: "This field is required" })),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { id: "text", type: "text", required: true, value: metaFormData.text, onChange: (e) => handleManualFieldChange(e, 'text'), disabled: disabled }),
                errors.text && (react_1.default.createElement("div", { className: "error-container" },
                    react_1.default.createElement("small", { className: "error-item" }, errors.text)))),
            react_1.default.createElement("div", { className: "form-group" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { htmlFor: "url" },
                    "URL",
                    react_1.default.createElement(RequiredFieldMarker_1.default, { tooltipMessage: "This field is required" })),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { id: "url", type: "text", required: true, value: metaFormData.url, onChange: (e) => handleManualFieldChange(e, 'url'), disabled: disabled }),
                errors.url && (react_1.default.createElement("div", { className: "error-container" },
                    react_1.default.createElement("small", { className: "error-item" }, errors.url))))))),
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { htmlFor: "target" }, "Open link"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { id: "target", as: "select", custom: true, value: target, onChange: handleTargetChange, disabled: disabled },
                react_1.default.createElement("option", { value: "_self" }, "In the current window or frame (browser default)"),
                react_1.default.createElement("option", { value: "_blank" }, "In a new window/tab"),
                react_1.default.createElement("option", { value: "_parent" }, "In the parent frame (defaults to current window if no frames)"),
                react_1.default.createElement("option", { value: "_top" }, "Forcefully in the current window (disregards any frames)")))));
};
exports.SquizLinkWidget = SquizLinkWidget;
